import Container from "@material-ui/core/Container";
import PrimaryCarousel from "../Carouselfold/CarouselComp";
import PrimaryDepro from "../HomeAbout";
import Primarymv from "../MissionandVision";
import Primarynews from "../Newsfold/Newsindex";
import SwipeableTextMobileStepper from "../Testimonials";
import ProjectsHome from "./projectsHome";
import ActivitiesHomeSection from "../Activityfold/ActivitiesHomeSection";

export default function Mobhome() {
  return (
    <div id="bg" style={{ width: "100%" }}>
      <div id="carsamob">
        <PrimaryCarousel url_slug="carousel" child_url="home" />
      </div>
      <div id="botcardsa">
        <Container
          style={{
            display: "flex",
            flexDirection: "column",
            marginTop: "-40px",
          }}
        >
          <div id="mobdepro" style={{ 
          position: "relative", 
          zIndex: 10,
          transform: "translate3d(0,0,0)" 
        }}>
            <PrimaryDepro />
          </div>
          <div id="newsindex">
            <Primarynews url_slug="news" child_url="news" />
          </div>
          <div>
            <Primarymv child_url="home" />
          </div>
        </Container>
      </div>
      <SwipeableTextMobileStepper />
      <div>
        <ActivitiesHomeSection />
      </div>
      <div>
        <ProjectsHome />
      </div>
    </div>
  );
}
